import { render, staticRenderFns } from "./ProductsGridNB.vue?vue&type=template&id=734ec23f&scoped=true"
import script from "./ProductsGridNB.vue?vue&type=script&lang=js"
export * from "./ProductsGridNB.vue?vue&type=script&lang=js"
import style0 from "./ProductsGridNB.vue?vue&type=style&index=0&id=734ec23f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734ec23f",
  null
  
)

export default component.exports